import React, { useState, useEffect } from "react"
import { get } from "lodash";
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"
import "react-calendar/dist/Calendar.css"
import loadable from "@loadable/component"

// import "./CalendarBlock.scss"
//import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import enGb from "date-fns/locale/en-GB"
// import ScrollAnimation from "react-animate-on-scroll"
import moment from "moment"
import { setMinutes, setHours, subDays, addDays } from "date-fns"
import CalendarIcon from "../assets/img/calendar-icon.svg"
import TimerIcon from "../assets/img/clock.svg"
import axios from 'axios';
import { getToken } from '@starberry/myaccount-website-utils';

const DatePicker = loadable(() => import("react-datepicker"));
//registerLocale("en-gb", enGb)


const CalendarBlock = ({startDate, setStartDate, fieldClass, labelClass, type, name, value, required, placeholder, handlechange, pattern, label, grpmd, step, inputlabel, min, max, maxlength, divclass, errorMsg, startTime, setStartTime, defaultValue, ...props}) => {

  const [slotsData, setSlotsData] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!calendarData && !loading) {
        setLoading(true)
        // const BASE_URL = "https://myaccount-package.q.starberry.com";
        // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyM2FhNGU2YWU0YjU3NjQ4ODdiYmY4YSIsImlhdCI6MTY3MzYwNTYzMCwiZXhwIjoxNjc2MTk3NjMwfQ.hdke485mkSHjD0W0S880_RH9bTC4FXCiO20zRK4KXM4"
        // // With header call
        // const authInstance = axios.create({
        //     baseURL: 'https://myaccount-package.q.starberry.com',
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //     },
        // });

        // authInstance.get('/stb-myaccount/property/MKT220287/getviewingavailabilities').then((res => {
        //   setSlotsData(res?.data)
        //     setLoading(false)
        // }))

        const BASE_URL = `${process.env.GATSBY_STRAPI_FORM_URL || process.env.GATSBY_STRAPI_SRC}`; // "https://myaccount-package.q.starberry.com";
        const token = getToken() || process.env.GATSBY_STRAPI_FORM_TOKEN; //"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyM2FhNGU2YWU0YjU3NjQ4ODdiYmY4YSIsImlhdCI6MTY3MzYwNTYzMCwiZXhwIjoxNjc2MTk3NjMwfQ.hdke485mkSHjD0W0S880_RH9bTC4FXCiO20zRK4KXM4"
        const propertyData = props?.propertyData || {};
        // With header call
        const authInstance = axios.create({
            baseURL: BASE_URL,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        authInstance.get(`/stb-myaccount/property/${propertyData.crm_id}/getviewingavailabilities`).then((res => {
            setSlotsData(res?.data)
            setLoading(false)
        }))
    }
  })

  const getDateFormat = (timestamp) => {
    if (!timestamp)
        return false;
    return moment(timestamp).format('YYYY-MM-DD');
  }

  const getTime = (timestamp) => {
    if (!timestamp)
        return false;
    return moment(timestamp).format('HH:mm');
  }

  const strToFullTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date(+'1995', '1', +'1', +hours, +minutes, +'0');
    return getTime(date)
  }

  const datePickerFormat = (timestamp) => {
    if (!timestamp)
        return false;
    return moment(timestamp).format('yyyy-MM-DD HH:mm');
  }

  const calendarData = props?.calendarData || slotsData;
  const [calStartDate, setCalStartDate] = React.useState();


  const [selectedItems, setSelectedItems] = React.useState({
      negotiator_id: /*calendarData?.negotiator_id ||*/ ``,
      start_time: calendarData?.start_time || ``,
      end_time: calendarData?.end_time || ``
  });

  const [slots, setSlots] = React.useState(() => {
      return []
  })

  const timeIntervals = 5; // get(calendarData, 'slots.duration', 60);
  const dayStart = get(calendarData, 'day_start', 0);
  const dayEnd = get(calendarData, 'day_end', 24);
  const slotes = get(calendarData, 'slots', {});
  const minDate = subDays(new Date(), -1)
  const maxDate = addDays(new Date(), 14)

  const updateSlots = (updateDate) => {
      const dateString = getDateFormat(updateDate);
      let daySlots = slotes[dateString] || []
      if (daySlots.length > 0) {
          let availableSlots = [];
          daySlots.map((item, key) => {
              let startTime = item.start_time.split(':');
              availableSlots.push(setHours(setMinutes(new Date(), startTime[1]), startTime[0]));
          });
          return availableSlots
      } else {
          return []
      }
  }

  // @todo: Need to play with start and end slot and load slot dynamic based on date select
  const onSelectFun = (data) => {
      const caleDate = new Date(data);
      setSlots(updateSlots(caleDate))
  }

  const dayClassNameFun = (day) => {
      const dateString = getDateFormat(day);
      let daySlots = slotes[dateString] || []
      return (daySlots.length) ? "has-slots" : "no-slots react-datepicker__day--disabled";
  }

  const timeClassNameFun = (time) => {
      return (time.getHours() >= dayStart &&  time.getHours() <= dayEnd) ? "allowed-slots" : "unallowed-slots";
  }

  const updateSlotDetailsFun = (updatedDate, updateStartDate=false) => {
      const dateString = getDateFormat(updatedDate);
      let daySlots = slotes[dateString] || []
      let selectedTime = getTime(updatedDate);
      if (daySlots && daySlots.length) {

          const matchingSlot  = daySlots.filter((x) => {
              let start_time = x.start_time.toString();
              if (start_time.length === 4)
                  start_time = strToFullTime(start_time)

              return (start_time === selectedTime)
          })

          if (matchingSlot.length > 0) {
              if (updateStartDate) {
                  setCalStartDate(updatedDate)
              }
              let selectedSlot = get(matchingSlot, '0', {})
              setSelectedItems({
                  negotiator_id: selectedSlot.negotiator_id,
                  start_time: selectedSlot.start_time,
                  end_time: selectedSlot.end_time
              })
              // props.handlechange(datePickerFormat(updatedDate))
              setStartDate(updatedDate)
              setStartTime(updatedDate)
          } else {
              if (updateStartDate && daySlots.length > 0) {
                  let firstSlot = get(daySlots, '0', {});
                  let firstSlotDateTime = get(firstSlot, 'start_time', '00:00').split(':');
                  let updateDateWithSlot = new Date(new Date(updatedDate).setHours(firstSlotDateTime[0], firstSlotDateTime[1], 0))
                  setCalStartDate(updateDateWithSlot)
                  setSelectedItems({
                      negotiator_id: firstSlot.negotiator_id,
                      start_time: firstSlot.start_time,
                      end_time: firstSlot.end_time
                  })
                  // props.handlechange(datePickerFormat(updatedDate))
                  setStartDate(updateDateWithSlot)
                  setStartTime(updateDateWithSlot)
              }
          }

      }
  }

  const onChangeFun = (date) => {
    updateSlotDetailsFun(date, true)
  }

  if (props?.defaultValue && !selectedItems?.start_time) {
    updateSlotDetailsFun(props.defaultValue)
  }

  return (
    <>
    <Form.Group as={Col} md={grpmd} className={`${type} ${step} ${divclass}`} controlId={"validation" + name}>
      <div className="custom-float">
        { label
          ? <Form.Label className="form-label">{label}{required ? ' *' : ''}</Form.Label>
          : ''
        }
        <DatePicker
          required
          selected={calStartDate}
          className={fieldClass}
          onChange={onChangeFun}
          showTimeSelect={false}
          timeIntervals={timeIntervals}
          includeTimes={slots}
          dateFormat="MMMM d, yyyy"
          timeFormat="HH:mm"
          minDate={minDate}
          onSelect={onSelectFun}
          maxDate={maxDate}
          minTime={setHours(setMinutes(new Date(), 0), dayStart)}
          maxTime={setHours(setMinutes(new Date(), 0), dayEnd)}
          calendarClassName={`myaccount-calendar`}
          dayClassName={dayClassNameFun}
          timeClassName={timeClassNameFun}
          placeholderText="Click to select date"
        />
        <img className="cal_icon" src={CalendarIcon} alt="Calender Icon" title="" />
      </div>
    </Form.Group>
    <Form.Group as={Col} md={grpmd} className={`${type} ${step} ${divclass}`} controlId={"validation" + name}>
      <div className="custom-float">
        { label
          ? <Form.Label className="form-label">{`Preferred Time`}{required ? ' *' : ''}</Form.Label>
          : ''
        }
        <DatePicker
          required
          selected={calStartDate}
          className={fieldClass}
          onChange={onChangeFun}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={timeIntervals}
          includeTimes={slots}
          dateFormat="HH:mm"
          timeFormat="HH:mm"
          minDate={minDate}
          onSelect={onSelectFun}
          maxDate={maxDate}
          minTime={setHours(setMinutes(new Date(), 0), dayStart)}
          maxTime={setHours(setMinutes(new Date(), 0), dayEnd)}
          calendarClassName={`myaccount-calendar`}
          dayClassName={dayClassNameFun}
          timeClassName={timeClassNameFun}
          placeholderText="Click to select time slot"
        />
        <img className="cal_icon" src={TimerIcon} alt="Calender Icon" title="" />
      </div>
    </Form.Group>
    </>
  )
}

export default CalendarBlock
